import { RouteErrorCard } from '@liza/ui/components/atoms/RouteErrorCard';
import { captureRouteError } from '@liza/ui/utils/captureRouteError';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';

// `defaultOnCatch` is handed only the error, so the route that failed comes off `router.state`.
const onRouteCatch = (error: Error, errorInfo: React.ErrorInfo): void => {
  // Only ever called from a mounted error boundary, long after `router` is assigned.
  // oxlint-disable-next-line no-use-before-define
  const { location, matches } = router.state;
  captureRouteError(error, errorInfo, {
    pathname: location.pathname,
    routeId: (matches.find((match) => match.status === 'error') ?? matches.at(-1))?.routeId,
  });
};

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultPreload: 'intent',
  context: {},
  // Internal users, so the raw message is worth surfacing.
  defaultErrorComponent: (props) => <RouteErrorCard {...props} showDetails />,
  defaultOnCatch: onRouteCatch,
});
